import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ApexAxisChartSeries } from 'ng-apexcharts';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({
  name: 'appDashboardChartSeries'
})
export class DashboardChartSeriesPipe implements PipeTransform {
  constructor(
    private translateService: TranslateService,
  ) {}

  public transform(bigChartStats: any[]): Observable<ApexAxisChartSeries> {
    const names = bigChartStats
      .map(item => item?.name)
      .filter(Boolean);

    if (!names.length) {
      return of([]);
    }

    return this.translateService.get(names)
      .pipe(
        map(
          (translations: Record<string, string>) => {
            return bigChartStats
              .map(item => {
                return ({
                  ...item,
                  data: item.isPercentage ? (item.data as number[]).map(dataitem => dataitem * 100) : item.data,
                  name: translations[item.name] || item.name,
                });
              });
          }
        ),
      );
  }
}
